import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { GLOBAL_CONTEXT } from '@adornis/users/db/a-roles.js';
import { checkPermissionMiddleware } from '../../permissions/middlewares/checkPermissionMiddleware.js';
import { Permission } from '../../permissions/roles.js';
import { resolveRecalculateAccountingEntry } from '../server/resolveRecalculateAccountingEntry.js';

const recalculateAccountingEntry = registerMutation({
  operationName: 'recalculateAccountingEntry',
  type: () => Boolean,
  params: [{ name: 'entryID', type: () => String }],
  // the permission of the admin dashboard, which also guards the import itself: it replays a whole school
  middlewares: [checkPermissionMiddleware(Permission.READ_PLATFORM_USAGE, GLOBAL_CONTEXT)],
  resolve: resolveRecalculateAccountingEntry,
});

export const AccountingResolutionAPI = {
  /** Recalculates who the entry belongs to. Runs in the background; the entry updates when it is through. */
  recalculateEntry: recalculateAccountingEntry,
};
